<template>
  <div class="img-and-content-container"
       :style="containerStyle">
    <div class="img-and-content-inner"
         :class="{ 'img-right': !eleConfig.otherConfig.imgLeftFlag }"
         :style="{gap: eleConfig.gap || 64 + 'px', alignItems: eleConfig.otherConfig.centerFlag ? 'center' : 'flex-start'}"
    >
      <div class="img-box">
        <template v-if="isVideo">
          <div class="video-mask" @click="changeVideoPlay">
            <dol-icon type="PlayCircleOutlined" v-if="!videoPlayFlag"/>
          </div>
          <video width="100%" height="auto" ref="video" autoplay
                 @play="videoPlay" @pause="videoPause" :src="imgSrc" />
        </template>
        <img v-else :src="imgSrc">
      </div>
      <div class="text-box">
        <h2 class="title" :style="{ color: eleConfig.otherConfig.titleColor }">
          {{ $dt(eleConfig, 'title') }}
        </h2>
        <div v-if="eleConfig.content" class="content"
             :style="{ color: eleConfig.otherConfig.contentColor, marginBottom: eleConfig.dataList.length ? '32px' : '0' }">
          {{ $dt(eleConfig, 'content') }}
        </div>
        <div v-if="eleConfig.dataList.length" class="data-list-box">
          <div class="data-row" v-for="row in eleConfig.dataList" :key="row._id">
            <div class="as-circle" :style="{backgroundColor: eleConfig.otherConfig.titleColor}"></div>
            <div class="data-text" :style="{ color: eleConfig.otherConfig.contentColor }">{{ $dt(row, 'title') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "imgAndContent",
  mixins: [componentMixin],
  data() {
    return {
      videoPlayFlag: true,
    };
  },
  computed: {
    containerStyle() {
      const style = {};
      if (this.eleConfig.backgroundImage) {
        const imgPath = this.$Dolphin.path.publicPath + this.eleConfig.backgroundImage.filePath;
        style.backgroundImage = `url(${imgPath})`;
      } else if (this.eleConfig.backgroundColor) {
        style.backgroundColor = this.eleConfig.backgroundColor;
      } else {
        style.backgroundColor = '#ffffff';
      }
      return style;
    },
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
    isVideo() {
      const fileInfo = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return /video/.test(fileInfo?.fileType || '')
    },
  },
  methods: {
    changeVideoPlay() {
      this.videoPlayFlag ? this.$refs.video.pause() : this.$refs.video.play();
    },
    videoPlay() {
      this.videoPlayFlag = true;
    },
    videoPause() {
      setTimeout(() => {
        this.videoPlayFlag = false;
      }, 50)
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;
    display: flex;

    &.img-right {
      flex-direction: row-reverse;
    }

    .img-box {
      flex: 1;
      position: relative;

      .video-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 64px;
        color: white;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .text-box {
      flex: 1;

      .title {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 16px;
        line-height: 45px;
        color: #003C82;
      }

      .content {
        font-size: 18px;
        white-space: pre-wrap;
        line-height: 25px;
        color: #333333;
      }
    }

    .data-list-box {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .data-row {
        display: flex;
      }

      .as-circle {
        height: 8px;
        width: 8px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-top: 8px;
        margin-right: 14px;
      }

      .data-text {
        flex: 1;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
}
</style>
